import React from 'react';
import { NovovilleButton, Typography } from '@/components/novoville';
import useTranslation from '@/shared/hooks/useTranslation';
import ReCAPTCHAInput from '../../auth/components/ReCAPTCHAInput';
import { BorderedPanel, PageShell } from './PanelLayout';

const PublicFormVerificationPanel = ({
  applicationTitle,
  isLoading,
  recaptchaToken,
  recaptchaKey,
  onCancel,
  onContinue,
  onVerify,
}) => {
  const translate = useTranslation();

  return (
    <PageShell>
      <BorderedPanel>
        <div className="flex flex-col gap-2">
          <Typography variant="bold_24">{applicationTitle}</Typography>
          <Typography variant="regular_16">
            {translate('publicFormApplication.continuePrompt')}
          </Typography>
        </div>

        <ReCAPTCHAInput key={recaptchaKey} onVerify={onVerify} />

        <div className="flex w-full flex-col gap-3 sm:flex-row">
          <NovovilleButton
            variant="primary"
            text={translate('publicFormApplication.continue')}
            disabled={!recaptchaToken || isLoading}
            onClick={onContinue}
          />
          <NovovilleButton
            variant="outline"
            text={translate('publicFormApplication.cancel')}
            onClick={onCancel}
          />
        </div>
      </BorderedPanel>
    </PageShell>
  );
};

export default PublicFormVerificationPanel;
